export default __webpack_public_path__ + "5a0321aab8f1d80892743cacbcf6a29f.png";